{
  "version": 1,
  "asset_id": "b71ad062-5e5c-4269-a49d-bced381c1674",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/b71ad062-5e5c-4269-a49d-bced381c1674/raindrop-wet-debris.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/b71ad062-5e5c-4269-a49d-bced381c1674/raindrop-wet-debris.mp4",
  "original_filename": "raindrop-wet-debris.mp4",
  "size": 11514750,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T17:18:14Z"
}
